import {
    DFP_AD_UNIT,
    Size,
    AD_UNIT_ROOTS,
    getPageSectionForAdUnit,
    AdvertSlotDfp,
    ADBRIDG_CLASS
} from '@zoopla/adverts/dfp';
import { queries } from '@zoopla-eng/zds/themes';

type SlotConfig = {
    listingZeroIdxPos: number;
    adUnitCode?: DFP_AD_UNIT;
    sizes: Size[];
    position?: number;
    adbridgClass?: string;
};

type Slot = {
    sizes: Size[];
    adbridgClass: ADBRIDG_CLASS;
};

const defaultMobileSlot: Slot = {
    sizes: [[320, 50], 'fluid'],
    adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_MOBILE
};

const defaultDesktopSlot: Slot = {
    sizes: [[728, 90], [728, 110], 'fluid'],
    adbridgClass: ADBRIDG_CLASS.INTERSTITIAL_DESKTOP
};

const getAdSlots = (slot: Slot): SlotConfig[] => [
    {
        ...slot,
        listingZeroIdxPos: 1,
        position: 1
    },
    {
        ...slot,
        listingZeroIdxPos: 4,
        position: 2
    },
    {
        ...slot,
        listingZeroIdxPos: 7,
        position: 3
    }
];

export const InlineAdSlot: React.FC<
    React.PropsWithChildren<{
        route: string;
        listingIndex: number;
        isMobile?: boolean;
        uuid?: string;
    }>
> = ({ route, listingIndex, isMobile = false, uuid }) => {
    const AD_SLOTS = getAdSlots(
        isMobile ? defaultMobileSlot : defaultDesktopSlot
    );

    const confIndex = AD_SLOTS.findIndex(
        ({ listingZeroIdxPos }) => listingZeroIdxPos === listingIndex
    );

    if (confIndex === -1) return null;

    const ad = AD_SLOTS[confIndex];

    return (
        <AdvertSlotDfp
            collapseEmpty
            showOnly={[isMobile ? '<' : '>', queries.M[100]]}
            sizes={ad.sizes}
            position={ad.position || 0}
            adUnitCode={
                ad.adUnitCode || [
                    AD_UNIT_ROOTS.INLINE,
                    getPageSectionForAdUnit(route),
                    '/Slot-' + ((ad.position || 0) + 1)
                ]
            }
            adbridgClass={ad.adbridgClass}
            uuid={uuid}
        />
    );
};
